import { setupAxios } from 'api/axios'
import { Loader } from 'components'
import { Providers } from 'config/Providers'
import { Suspense } from 'react'
import 'config/i18n'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/dropzone/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/spotlight/styles.css'
import '@mantine/code-highlight/styles.css'
import 'config/global.css'
import 'leaflet/dist/leaflet.css'
import Router from 'views/Router'

setupAxios()
function App() {
  return (
    <Providers>
      <Suspense fallback={<Loader />}>
        <Router />
      </Suspense>
    </Providers>
  )
}

export default App
